import { useEffect, useState } from 'react'

// Matches Tailwind's `sm` breakpoint (640px) -- below it counts as mobile.
const MOBILE_QUERY = '(max-width: 639px)'

/**
 * Mounts one layout or the other, not both hidden-by-CSS side by side --
 * same reasoning AppShell.tsx's mobile drawer already follows (only
 * mounted while open, not always-present-but-hidden), because two
 * simultaneously-mounted copies of the same content make every text/
 * testid locator in this app's Playwright suite ambiguous ("resolved to
 * 2 elements") regardless of which one is visually hidden. Used by
 * Reminders.tsx's responsive table/card-list switch (2026-09-26, portal
 * usability review item 2).
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(MOBILE_QUERY).matches
      : false,
  )

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(MOBILE_QUERY)
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [])

  return isMobile
}
